import { PERMISSIONS } from "../../constants/permissions";

// The PLM sidebar. Item shape: components/layout/shell/Sidebar.jsx.

export const PLM_SECTIONS = [
  {
    items: [
      { to: "/dashboard", label: "Home", icon: "home", permission: PERMISSIONS.PROJECT_VIEW_ALL },
      // The badge counts unread Inbox items, which live under My Tasks.
      { to: "/tasks", label: "My Tasks", icon: "tasks", badge: "inbox", permission: PERMISSIONS.TASK_VIEW },
    ],
  },
  {
    title: "Projects",
    items: [
      {
        to: "/projects",
        label: "All Projects",
        icon: "projects",
        end: true,
        permission: [
          PERMISSIONS.PROJECT_VIEW_ALL,
          PERMISSIONS.PROJECT_VIEW_ASSIGNED,
          PERMISSIONS.PROJECT_ASSIGN_USERS,
        ],
      },
      { to: "/projects/archived", label: "Archived", icon: "archive", permission: PERMISSIONS.PROJECT_DELETE },
    ],
  },
  {
    title: "Planning",
    items: [
      { to: "/schedule", label: "My Schedule", icon: "schedule", permission: PERMISSIONS.SCHEDULE_VIEW_OWN },
      { to: "/planner", label: "Planner", icon: "planner" },
    ],
  },
  {
    title: "Insights",
    items: [
      { to: "/team", label: "Team", icon: "team", permission: PERMISSIONS.TEAM_ACTIVITY_VIEW_OWN },
      {
        to: "/invoicing",
        label: "Invoicing",
        icon: "invoice",
        permission: PERMISSIONS.INVOICING_VIEW,
        visible: ({ invoicingEnabled }) => Boolean(invoicingEnabled),
      },
    ],
  },
];

export const PLM_ADMIN = {
  label: "Admin",
  icon: "settings",
  items: [
    { to: "/admin/users", label: "Users", icon: "users", permission: PERMISSIONS.USER_VIEW_ALL },
    { to: "/admin/roles", label: "Roles", icon: "roles", permission: PERMISSIONS.ROLE_VIEW },
    { to: "/admin/workflows", label: "Workflows", icon: "workflow", permission: PERMISSIONS.WORKFLOW_MANAGE_EDIT },
    {
      to: "/admin/schedule-settings",
      label: "Schedule Settings",
      icon: "scheduleSettings",
      permission: PERMISSIONS.SCHEDULE_CONFIGURE_ORG,
    },
    { to: "/admin/customizations", label: "Customizations", icon: "customize", adminOnly: true },
    // Admin-only by design — the audit trail is never granted through a role's permissions.
    { to: "/admin/audit-logs", label: "Audit Trail", icon: "audit", adminOnly: true },
    // Admins reach AI Access here, where it lists the whole workspace's
    // connections; everyone else reaches it from the profile menu.
    { to: "/ai-access", label: "AI Access", icon: "link", adminOnly: true },
  ],
};
